/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, Modal, InputSelect, Pagination, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { GroupServices } from "../../../../Services/equipamentosServices/group";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeLoationtypes, changeModal } from "../../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, ContainerList, HeaderContainer, 
    InputContainer, FilterInput, ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn, ContentHeader } from "./styles";

import { PageTitle } from "../../../styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListGroups = () => {
    // const navigate = useNavigate();
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.groups.list.document-title");

    const Services = useRef(new GroupServices());
    
    const alocacao_typeField = useRef();
    const alocacaoField = useRef();
    const NameField = useRef();
    const StateField = useRef();
    const CityField = useRef();
    const LatField = useRef();
    const LongField = useRef();
    const Typefiled = useRef();
    
    const alocacaoValue = useRef();
    const NameValue = useRef();
    const CityValue = useRef();
    const LatValue = useRef();
    const LongValue = useRef();
    const searchValue = useRef();
    const TypeValue = useRef();
    
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const user = useSelector(state => state.userReducer);
    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);
    let active = useSelector(state => state.ModalReducer.name);

    const EquipamentsType = [
        {
            id: "1f4d0674-1e7a-48c5-925f-87e2d99bcda5",
            name: 'Analisador'
        },
        {
            id: 'e2a17428-badd-4b2a-ace9-7f428f78cc1f',
            name: 'ETA',
        },
        {
            id: '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1',
            name: 'Macro Medidor',
        },
        {
            id: '8831aa23-aa96-468f-bd48-10463cdaea6b',
            name: 'Reservatório'
        },
        {
            id: 'de4a6821-eb4c-492b-96c1-7ab704f053f6',
            name: 'Hidrômetro',
        },
        {
            id: 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6',
            name: 'Sensor de nível'
        },
        {
            id: '52e63208-66ed-4a57-b41f-6f93b1b12f76',
            name: 'LORA'
        },
    ];

    // Busca os grupos de equipamentos
    const getGroups = async() => {
        setIsLoading(true);
        let currentGroups = await Services.current.getAllGroups();
        setGroups(currentGroups);
        setIsLoading(false);
    }

    // Busca alocações do usuário
    const getLocations = async() => {
        try {
            let AllLocations = await Services.current.getLocations();

            let Types = Object.keys(AllLocations).map(type => {
                return{
                    id: type,
                    name: type
                }
            })
            store.dispatch(changeLoationtypes(Types));
        } catch (error) {
            
        }
    }

    const getStates = async() => {
        try {
            let States = await Services.current.getStates();
            setStates(States);
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getGroups();
        getLocations();
        getStates();
    }, []);

    const aplyFilter = async() => {
        setIsLoading(true);
        let currentGroups = await Services.current.getAllGroups(searchValue.current);
        setGroups(currentGroups);
        setIsLoading(false);
    }

    // Salva as edições do usuário
    async function Save(){
        if(isValidField(NameValue.current) && isValidField(CityValue.current) && isValidField(LatValue.current) && isValidField(LongValue.current)
            && isValidField(alocacaoValue.current)){
            let form = new FormData();
                
            if(NameValue.current){form.append('name', NameValue.current)}
            if(alocacaoValue.current){form.append('id_allocation', alocacaoValue.current)}
            if(CityValue.current){form.append('city_code', CityValue.current)}
            if(LatValue.current){form.append('latitude', LatValue.current)}
            if(LongValue.current){form.append('longitude', LongValue.current)}
            if(TypeValue.current){form.append('id_icon_type', TypeValue.current)}
            if(TypeValue.current === 'e2a17428-badd-4b2a-ace9-7f428f78cc1f'){form.append('eta', 1)}else{form.append('eta', 0)}

            Services.current.SaveGroup(form);
            store.dispatch(changeModal(''));
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const changePage = async(page) => {
        setIsLoading(true);
        let currentGroups = await Services.current.getAllGroups(searchValue.current, page);
        setGroups(currentGroups);
        setIsLoading(false);
    }

    const ChangeCities = async(state) => {
        try {
            let Cities = await Services.current.getCities(state);
            setCities(Cities);
        } catch (error) {
            
        }
    }

    return(
        <>
            <Container>

                <PageTitle>
                    {t("administrative.sub-items.groups.list.page-title")}
                </PageTitle>

                <HeaderContainer>
                    <ContentHeader>
                        <InputContainer>
                            <img src={Lupa} alt={t("inputs.search-group.alt")}></img>
                            <FilterInput
                                // onBlur={()=>Aplyfilter()}
                                onKeyDown={(e) => e.key === 'Enter' && aplyFilter()}
                                onChange={(e) => searchValue.current = e.target.value}
                                placeholder={t("inputs.search-group.placeholder")}
                            />
                        </InputContainer>

                        <Button width={'fit-content'} text={t("buttons.apply")} color={'green'} onClick={() => aplyFilter()}></Button>
                    </ContentHeader>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + groups?.meta?.total + " " + t("administrative.sub-items.groups.list.groups")}
                    </CountContainer>
                    {user?.user?.can?.includes('group.create') ?
                        <Button onClick={() => store.dispatch(changeModal('newgroup'))} width={'fit-content'} color={'green'} icon={''} text={t("buttons.register-group")}></Button>
                    :<></>}
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.name")}</TitleText>
                        <TitleText>{t("header-table.city")}</TitleText>
                        <TitleText>{t("header-table.allocation")}</TitleText>
                    </LineTitle>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        groups?.data?.map((item) => (
                            <LineList key={item.id} href={user?.user?.can?.includes('group.view') ? `/adm/grupos/${item.id}` : undefined}>
                                <ListText>{item.name}</ListText>
                                <ListText>{item.city?.name}</ListText>
                                <ListText>{item.allocation.name}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>

                {isLoading?
                    <></>
                :<Pagination last_page={groups?.meta?.last_page} currentpage={groups?.meta?.current_page} changepage={changePage}/>}

            </Container>
            
            <Modal title={t("modal.register-group.title")} name={'newgroup'} width={'70%'} height={'90%'} > 
                {active === 'newgroup' ?
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <Label text={t("inputs.name.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.name.placeholder")}
                                    innerRef={NameField}
                                    invalidMessage={t("inputs.name.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => NameValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.state.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'state'}
                                    id={'state'}
                                    placeholder={t("inputs.state.placeholder")}
                                    invalidMessage={t("inputs.state.invalid-message")}
                                    options={states}
                                    innerRef={StateField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => ChangeCities(value)}>
                                </InputSelect>

                                <Label text={t("inputs.city.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'city'}
                                    id={'city'}
                                    placeholder={t("inputs.city.placeholder")}
                                    invalidMessage={t("inputs.city.invalid-message")}
                                    options={cities}
                                    innerRef={CityField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => CityValue.current = value}>
                                </InputSelect>
                            </ContainerColumn>
                            
                            <ContainerColumn>
                                <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao_type'}
                                    name={'alocacao_type'}
                                    id={'alocacao_type'}
                                    placeholder={t("inputs.allocation-type.placeholder")}
                                    invalidMessage={t("inputs.allocation-type.invalid-message")}
                                    options={LocationTypes}
                                    innerRef={alocacao_typeField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => Services.current.ChangeLocationType(value, alocacaoField.current)}>
                                </InputSelect>

                                <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao'}
                                    name={'alocacao'}
                                    id={'alocacao'}
                                    placeholder={t("inputs.allocation-local.placeholder")}
                                    invalidMessage={t("inputs.allocation-local.invalid-message")}
                                    options={Locations}
                                    innerRef={alocacaoField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => alocacaoValue.current = value}>
                                </InputSelect>

                                <Label text={t("inputs.group-icon.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'equipament'}
                                    id={'equipament'}
                                    placeholder={t("inputs.group-icon.placeholder")}
                                    invalidMessage={t("inputs.group-icon.invalid-message")}
                                    options={EquipamentsType}
                                    innerRef={Typefiled}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        TypeValue.current = value
                                    }}>
                                </InputSelect>
                            </ContainerColumn>

                            <ContainerColumn>  
                                <Label text={t("inputs.latitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='latitude' 
                                    name='latitude' 
                                    type="text" 
                                    placeholder={t("inputs.latitude.placeholder")}
                                    innerRef={LatField}
                                    invalidMessage={t("inputs.latitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => LatValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.longitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder= {t("inputs.longitude.placeholder")}
                                    innerRef={LongField}
                                    invalidMessage={t("inputs.longitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => LongValue.current = text}> 
                                </Input>
                            </ContainerColumn>
                        </ContainerRow>

                        <ButtonsContainer>
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                            <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                        </ButtonsContainer>
                    </>
                :<></>}
            </Modal>
        </>
    )
}

export default ListGroups;